
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.332.015H1.577C.71.015.005.72.005 1.586v3.755c0 .867.705 1.572 1.572 1.572h3.755c.866 0 1.571-.705 1.571-1.572V1.586C6.903.72 6.198.015 5.332.015zm.372 5.326a.372.372 0 01-.372.373H1.577a.372.372 0 01-.373-.373V1.586c0-.205.167-.372.373-.372h3.755c.205 0 .372.167.372.372v3.755zM0 13.88c0 .867.705 1.572 1.572 1.572h3.755c.866 0 1.571-.705 1.571-1.572v-3.755c0-.867-.705-1.572-1.571-1.572h-3.75c-.867 0-1.572.705-1.572 1.572v3.755H0zm1.2-3.76c0-.206.166-.372.372-.372h3.755c.205 0 .372.166.372.372v3.755a.372.372 0 01-.372.372h-3.75a.372.372 0 01-.373-.372V10.12H1.2zM0 22.414c0 .866.705 1.571 1.572 1.571h3.755c.866 0 1.571-.705 1.571-1.571v-3.756c0-.866-.705-1.571-1.571-1.571h-3.75c-.867 0-1.572.705-1.572 1.572v3.755H0zm1.2-3.756c0-.205.166-.372.372-.372h3.755c.205 0 .372.167.372.372v3.756a.372.372 0 01-.372.372h-3.75a.372.372 0 01-.373-.372v-3.756H1.2zM13.745 4.064h9.814c.242 0 .438-.27.438-.603 0-.332-.196-.602-.438-.602h-9.814c-.242 0-.438.27-.438.602 0 .333.196.603.438.603z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M9.971 4.06h2.358a.427.427 0 00.333-.176.692.692 0 00.138-.424c0-.16-.05-.312-.138-.424a.427.427 0 00-.333-.176H9.97a.427.427 0 00-.333.176.692.692 0 00-.138.424c0 .16.05.312.138.424a.427.427 0 00.333.176z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M9.91 12.602h13.488a.602.602 0 100-1.204H9.909a.602.602 0 100 1.204zM9.91 21.136h13.488a.602.602 0 100-1.205H9.909a.602.602 0 100 1.205z","fill":"#00003C"}})])
          )
        }
      }
    